import { __extends } from "tslib";
import { UpdateShardCountInput, UpdateShardCountOutput } from "../models/models_0";
import { deserializeAws_json1_1UpdateShardCountCommand, serializeAws_json1_1UpdateShardCountCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateShardCountCommand = /** @class */ (function (_super) {
    __extends(UpdateShardCountCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateShardCountCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateShardCountCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "UpdateShardCountCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: UpdateShardCountInput.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateShardCountOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateShardCountCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1UpdateShardCountCommand(input, context);
    };
    UpdateShardCountCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1UpdateShardCountCommand(output, context);
    };
    return UpdateShardCountCommand;
}($Command));
export { UpdateShardCountCommand };
//# sourceMappingURL=UpdateShardCountCommand.js.map